import type { DataLayerEntry } from './types';

// A JSON round-trip, not structuredClone: GTM must not receive keys whose value is undefined,
// and structuredClone keeps them.
export const withoutUndefinedValues = (data: object): DataLayerEntry => JSON.parse(JSON.stringify(data));
